function SiteSidebarController($scope, $sce, authService, dataService) {
    $scope.posts = [];
    var ready = false;

    var loadContent = function() {
        if (ready) return;
        ready = true;
        var authTag = authService.accessToken ? 'hash-auth' : 'hash-noauth';
        dataService.contentApi.posts.browse({limit: 3, filter: 'tag:hash-sidebar+tag:' + authTag})
            .then(function(posts) {
                $scope.posts = _.map(posts, function(post) {
                    post.trustedHtml = $sce.trustAsHtml(post.html);
                    return post;
                });
                $scope.$apply();
            })
            .catch(function(err) {
                console.error(err);
                $scope.post = [];
            });
    };

    $scope.$on('auth.ready', loadContent);
    $scope.$on('auth.login', loadContent);
    $scope.$on('auth.logout', loadContent);

    setTimeout(loadContent, 100);
}

function SiteSidebarQuoteController($scope, $sce, dataService) {
    $scope.post = null;
    this.$postLink = function() {
        if (!dataService.contentApi) return;
        dataService.contentApi.posts.browse({limit: 100, filter: 'tag:hash-quote'})
            .then(function(posts) {
                if (posts.length <= 0) {
                    $scope.post = null;
                    return;
                }
                $scope.post = posts[Math.floor(Math.random() * Math.floor(posts.length))];
                $scope.post.trustedHtml = $sce.trustAsHtml($scope.post.html);
                $scope.$apply();
            })
            .catch(function(err) {
                console.error(err);
                $scope.post = null;
            });
    };
}

angular.module('app')
    .component('siteSidebar', {
        transclude: true,
        controller: ['$scope', '$sce', 'authService', 'dataService', SiteSidebarController],
        templateUrl: '/assets/built/app/components/siteSidebar/sidebar.html'
    })
    .component('siteSidebarQuote', {
        transclude: true,
        controller: ['$scope', '$sce', 'dataService', SiteSidebarQuoteController],
        templateUrl: '/assets/built/app/components/siteSidebar/quote.html'
    });
